import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL;

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// -------- DO NOT CHANGE THIS CONSTANT ---------
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export const PROD_BD_API_URL = "https://api.wishlink.com/api/bd/";
export const PROD_ATG_API_URL = "https://api.wishlink.com/api/";
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

const axiosInstance = axios.create({
  baseURL: PROD_BD_API_URL,
  timeout: 1000 * 60 * 10,
  headers: { "Content-Type": "application/json" },
});

export const atgAxiosInstance = axios.create({
  baseURL: PROD_ATG_API_URL,
  timeout: 1000 * 60 * 10,
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use((config) => {
  const emailUserToken =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  const brandAdminToken =
    localStorage.getItem("Token") || sessionStorage.getItem("Token");
  if (emailUserToken) {
    config.headers.Authorization = `AuthToken ${emailUserToken}`;
  } else if (brandAdminToken) {
    config.headers.Authorization = `Token ${brandAdminToken}`;
  }
  return config;
});

export default axiosInstance;
